import quote from "./images/quote.png";
import atomPro from "./images/atomPro.svg";
import mail from "./images/mail.svg";
import logo from "./images/logo.svg";
import atomByViderLogo from "./images/atomByViderLogo.png";
import loginBg from "./images/login_bg.png";
import whiteLogo from "./images/white_logo.svg";
import dashboard from "./icons/dashboard.svg";
import approvals from "./icons/approvals.svg";
import taskboard from "./icons/taskboard.svg";
import calendar from "./icons/calendar.svg";
import lmi from "./icons/lmicon.png";
import checklist_PosterImage from "./icons/checklist_PosterImage.png";
import handshake_PosterImage from "./icons/handshake_PosterImage.png";
import socialmedia_PosterImage from "./icons/socialmedia_PosterImage.png";
import calendar_PosterImage from "./icons/calendar_PosterImage.png";
import taskCompleted from "./icons/taskCompleted.svg";
import totalClients from "./icons/totalClients.svg";
import taskInprogress from "./icons/taskInprogress.svg";
import taskTodo from "./icons/taskTodo.svg";
import taskUnderReview from "./icons/taskUnderReview.svg";
import totalTasks from "./icons/totalTasks.svg";
import invoicing from "./icons/invoicing.svg";
import clients from "./icons/clients.svg";
import leads from "./icons/leads.svg";
import register from "./icons/register.svg";
import dsc from "./icons/dsc.svg";
import gstReturns from "./icons/gstReturns.svg";
import storage from "./icons/storage.svg";
import storage_sync from "./icons/storage_sync.svg";
import team from "./icons/team.svg";
import reports from "./icons/reports.svg";
import settings from "./icons/settings.svg";
import broadcast from "./icons/broadcast.svg";
import logout from "./icons/logout.svg";
import man from "./icons/man.svg";
import profile from "./icons/profile.svg";
import date from "./icons/calendar.png";
import shuffle from "./icons/shuffle.svg";
import formIcon from "./icons/formIcon.svg";
import empty from "./images/empty.svg";
import user from "./icons/user.png";
import folder from "./icons/folder.png";
import pdf from "./icons/filetypes/pdf.png";
import json from "./icons/filetypes/json.png";
import doc from "./icons/filetypes/docs.png";
import excel from "./icons/filetypes/excel.png";
import csv from "./icons/filetypes/csv.png";
import text from "./icons/filetypes/text.png";
import ppt from "./icons/filetypes/ppt.png";
import zip from "./icons/filetypes/zip.png";
import video from "./icons/filetypes/video.png";
import audio from "./icons/filetypes/audio.png";
import recurring from "./icons/recurring.svg";
import singleLine from "./icons/singleLine.svg";
import email from "./icons/email.svg";
import address from "./icons/address.svg";
import multiLine from "./icons/multiLine.svg";
import name from "./icons/name.svg";
import checkBox from "./icons/checkBox.svg";
import fileUpload from "./icons/fileUpload.svg";
import imageUpload from "./icons/imageUpload.svg";
import termsAndConditions from "./icons/termsAndConditions.svg";
import currency from "./icons/currency.svg";
import signature from "./icons/signature.svg";
import dropDown from "./icons/dropDown.svg";
import decisionBox from "./icons/decisionBox.svg";
import fieldDate from "./icons/date.svg";
import mobileNumber from "./icons/mobileNumber.svg";
import numbers from "./icons/number.svg";
import profileImage from "./images/profile.jpg";
import noAttachments from "./images/no_attachments.svg";
import noSubTasks from "./images/noSubTasks.svg";
import noChecklists from "./images/noChecklists.svg";
import noMilestones from "./images/noMilestones.svg";
import noDueDiligence from "./images/noDueDiligence.svg";
import noEvents from "./images/noEvents.svg";
import signup from "./images/signup.png";
import newlogo from "./images/newlogo.png";
import emptyLicenses from "./images/emptyLicenses.png";
import createFormLanding from "./images/createFormLanding.png";
import clientFormCard from "./images/clientFormCard.png";
import file from "./icons/file.png";
import atom_logo from "./images/atom_logo.png";
import todo from "./images/todo.png";
import completed from "./images/completed.png";
import terminated from "./images/terminated.png";
import deleted from "./images/deleted.png";
import onhold from "./images/onhold.png";
import onedrive from "./icons/onedrive.png";
import folderIcon from "./icons/folder.svg";
import emptyGroup from "./images/GroupEmpty.png";
import googleCalendar from "./images/google-calendar.png";
import atom_logo_no_background from "./images/atom_logo_no_background.jpeg";
import vider_logo from "./images/vider_logo.jpeg";
import inprog from "./images/inprog.png";
import underrev from "./images/underreview.png";
import terminate from "./images/terminate.png";
import Quantum from "./images/Quantum.png";
import documents from "./images/documents.png";
import vider_logo_white from "./images/vider_logo_white.jpeg";
import serviceopg1 from "./images/serviceopg1.jpg";
import dsc_Poster_Image from "./icons/dsc_Poster_Image.png";
import file_Poster_Image from "./icons/file_Poster_Image.png";
import recuring from "./icons/recurring.svg";
import vider_transparent from "./images/vider_transparent.png";
import vider_v from "./images/vider_v.png";
import clone_file from "./images/clone_file.png";
import canceled from "./images/canceled.png";
import atom_maintainence from "./images/Atom Maintenance.jpg";
import it from "./images/incomeTax.png";
import tds from "./images/incomeTaxTds.png";
import gst from "./images/incomeTaxGst.jpeg";
import downloadPdf from "./images/Downlaodpdf.png";
import downloadWord from "./images/DownlaodDocs.png";
import quantumRequestImg from "./images/quantunRequest.jpg";
import incomeTaxPortal from "./images/incomeTaxPortal.png";
import itO from "./images/incomeTaxOpacity.png";
import incomeTaxTan from "./images/IncomeTaxTAN.png";
import incomeTaxCa from "./images/IncomeTax CA.png";
import incomeTaxPan from "./images/Income Tax _ PAN.png";
import traces from "./images/Traces.png";
import gstImg from "./images/GST.png";
import todoIcon from "./images/todoI.png";
import inprogressIcon from "./images/inPro.png";
import underreviewIcon from "./images/ur.png";
import deletedIcon from "./images/del.png";
import pendingIcon from "./images/pendi.png";
import onholdIcon from "./images/onhol.png";
import completedIcon from "./images/com.png";
import terminateI from "./images/TerminateIcon.png";
import totalTasksIcon from "./images/all.png";
import DashboardEdit from "./images/DashboardEdit.png";
import gstdashboard from "./images/GSTDashboard.png";
import incomeTaxDashboard from "./images/taxdashboard.png";
import incomeTaxPanOrg from "./images/IncomeTaxPANOrg.png";
import verificationPending from "./images/statusPending.png";
import verificationComplete from "./images/statusComplete.png";
import day7 from "./images/day7.png";
import invalidPassword from "./images/invalidPassword.png";
import validPassword from "./images/validPassword.png";
import submitOn from "./images/SubmitOn.png";
import returnBelated from "./images/returnBelated.png";
import returnDefective from "./images/returnDefective.png";
import returnOriginal from "./images/returnOriginal.png";
import returnRectification from "./images/returnRectification.png";
import returnRevised from "./images/returnRevised.png";
import atomProLogo from "./images/atomProLogo.png";
import returnUpdated from "./images/returnUpdated.png";
import notApplicable from "./images/notApplicable.png";
import issuedOn from "./images/issuedOn.png";
import last15days from "./images/day15.png";
import month1 from "./images/month1.png";
import registerIcon from "./images/register.png";
import gstrReturns from "./images/gstr-returns.png";
import mulitpleClients from "./images/multiple-users-silhouette.png";
import mulitipleClient from "./images/people.png";
import primaryclient from "./images/primaryclient.png"
import importPic from "./images/importPic.png";
import gmail from "./images/gmail.png";
import outlook from "./images/outlook.png";
import yahoo from "./images/yahoo.png";
import broadcastLogo from "./images/broadcastLogo.svg";
import EmptyFolder from "./images/empty-folder 3.png";
import mailLogo from "./images/mailLogo.png";
import ViderAI from "./icons/ai.svg";
import tanTracesLogo from "./images/incomeTaxTanTraces.png";
import mobileMfa from "./images/mobileMfa.png";
import atomCenter from "./images/atomCenter.png";
import word from "./images/word.png";
import xls from "./images/xls.png";
import Reminder from "./images/Reminder.png";
import remainder_icon from "./images/remainder_icon.png";
import budgetedhours from './images/budgetedhours.png';
import variance from './images/vairance.png';
import actualhours from './images/actualhours.png';
import coupon_code from './images/coupon_code.png';
import clients_mems from './images/clients_mems.png';
import valid_creds from './images/valid_creds.png';
import invalid_creds from './images/invalid_creds.png';
import gstNotOrds from './images/gst_not_ords.png';
import addNotOrds from './images/gst_add_not_ords.png';
import last7Days from './images/7days.png';
import last24Hrs from './images/Last24h.png';
import last15Days from './images/15days.png';
import dueDt from './images/DueDate.png';
import issuanceDt from './images/IssuanceDate.png';
import lastMonth from './images/30days.png';
import closed from './images/Closed.png';
import open from './images/Open.png';
import replied from './images/Replied.png';
import notReplied from './images/Not Replied.png';
import overAll from './images/Overall.png';
import hourGlass from './images/hourglass.png';
import maximize from './images/maximize.gif';
import animatedNav from './images/animated_nav.png';
import oneDay from './images/oneDay.png';
import totalnoclients from './images/totalnoclients.png';
import lm from './images/licensemanagement.png';
import NoOfTasks from './images/NoOfTasks.png';
import presentDashboard from './images/Present-Dashboard.png';
import absentDashboard from './images/Absent-Dashboard.png';
import leaveDashboard from './images/Leave-Dashboard.png';
import birthday from './images/birthday.png';
import whatsNew from './images/whatsNew.png';
import holidayDashboard from './images/Holiday-Dashboard.png';
import notMarkedDashboard from './images/archive.png';
import fisrtHalf from './images/fisrtHalf.png';
import secoundHalf from './images/secoundHalf.png';
import tdsLOGO from './images/tds-dashboard.png';
import clientRequest from './images/Client Request.png';
import mca from './images/MCA.png';
import McaMasterData from './icons/mca-master-data.png';
import McaFilingStatus from './icons/mca-filling-status.png';
import McaCompanyDetails from './icons/mca-companyorllp.png';
import McaDashboard from './icons/mca-dashboard.png';
import McaClients from './icons/mca-clients.png';
import McaServices from './icons/mca-service.png';
import McaLateFeeCalculator from './icons/mca-calculator.png';
import McaLateFeeCalculators from './icons/mca-calculators.png';
import HelpAndResources from './icons/book.png';
import alerttt from './icons/alert.gif';
import planner from './images/planner.png';
import teamscore from "./images/teamscore.png";
import taskassigned from "./images/taskassigned.png";
import taskcompleted from "./images/taskscompleted.png";
import tick from "./images/tick.png";
import plannerWOkring from "./images/plannerWorking.png";
import suitcase from "./images/suitcase.png";
import clock from "./images/clock.png";
import MCA from './images/mcaimage.jpg.jpeg';
import BotIcon from './images/ChatIcon.png';
import zoho_logo from './images/zoho_logo.png';
import whatsappBg from './images/whatsapp_bg.png';
import sync from './images/sync.png';
import social from './images/social.png';
import viderconnectlogo from './images/viderconnectlogo.png';
import viderconnecticon from './images/viderconnecticon.png';
import checkIcon from './images/check-icon.png';
import unifiedCompliance from './images/unifiedCompliance.png';
import UPI from './images/UPI.svg';
import audit from './icons/audit.svg';
import viderIcon from "./images/Vider.png";
import redVouchLogo from "./images/RedVouchLogo.png";
import redVouchCard from "./images/RedVouch.png";
import brandIllustration from "./images/Backgrouund.jpg.jpeg";
import viderConnect from "./images/ViderConnect.png";
import AtomCard from "./images/AtomCard.png";
import AtomProCard from "./images/AtomProCard.png";
import playStoreIcon from "./images/playStoreIcon.png"
import appStoreIcon from "./images/appStoreIcon.png"
import Verified1 from "./images/verified1.png";
import Verified2 from "./images/verified2.png";
import Verified3 from "./images/verified3.png";
import Verified4 from "./images/verified4.png";
import DpiitEriSslIso from "./images/dpiitEriSslIso.png";
import SignupBackground from "./images/SignupBackground.jpeg";
import ViderLogoFull from "./images/viderLogoFull.png"; 
import CALOGO from "./images/CALOGO.jpeg"
import manualDueDt from './images/manualDueDate.png';
import trademarklogo from "./images/Trademark logo.png";
import knowledgebaseicon from "./images/knowledge base.png";
import openicon from "./images/Open Icon.png";
import ITALogo from "./images/ITA.png";
import GSTAT_ATOM_PRO_LOGO from './images/GSTAT_ATOM_PRO_LOGO.png'
import faceCaptureGuide from "./images/face-capture-guide.png"

export {
  todo,
  inprog,
  completed,
  terminate,
  deleted,
  onhold,
  underrev,
  quote,
  recuring,
  logo,
  whatsappBg,
  loginBg,
  whiteLogo,
  empty,
  profileImage,
  noAttachments,
  noSubTasks,
  noChecklists,
  noMilestones,
  noDueDiligence,
  noEvents,
  signup,
  newlogo,
  emptyLicenses,
  createFormLanding,
  clientFormCard,
  atom_logo,
  emptyGroup,
  atomByViderLogo,
  googleCalendar,
  atom_logo_no_background,
  Quantum,
  documents,
  serviceopg1,
  vider_logo_white,
  vider_logo,
  vider_transparent,
  vider_v,
  clone_file,
  downloadWord,
  downloadPdf,
  canceled,
  atom_maintainence,
  tds,
  it,
  gst,
  quantumRequestImg,
  incomeTaxPortal,
  itO,
  incomeTaxTan,
  incomeTaxCa,
  incomeTaxPan,
  traces,
  gstImg,
  todoIcon,
  inprogressIcon,
  underreviewIcon,
  deletedIcon,
  pendingIcon,
  onholdIcon,
  completedIcon,
  terminateI,
  totalTasksIcon,
  incomeTaxPanOrg,
  verificationPending,
  verificationComplete,
  day7,
  invalidPassword,
  validPassword,
  submitOn,
  returnBelated,
  returnDefective,
  returnOriginal,
  returnRectification,
  returnUpdated,
  returnRevised,
  atomProLogo,
  issuedOn,
  notApplicable,
  last15days,
  month1,
  gstrReturns,
  mulitpleClients,
  mulitipleClient,
  primaryclient,
  importPic,
  gmail,
  outlook,
  yahoo,
  EmptyFolder,
  mailLogo,
  tanTracesLogo,
  mobileMfa,
  atomCenter,
  word,
  xls,
  Reminder,
  remainder_icon,
  budgetedhours,
  actualhours,
  variance,
  coupon_code,
  clients_mems,
  valid_creds,
  invalid_creds,
  gstNotOrds,
  addNotOrds,
  last7Days,
  last24Hrs,
  last15Days,
  dueDt,
  issuanceDt,
  lastMonth,
  open,
  closed,
  replied,
  notReplied,
  overAll,
  hourGlass,
  maximize,
  animatedNav,
  oneDay,
  DashboardEdit,
  gstdashboard,
  incomeTaxDashboard,
  totalnoclients,
  lm,
  NoOfTasks,
  presentDashboard,
  absentDashboard,
  leaveDashboard,
  birthday,
  whatsNew,
  holidayDashboard,
  notMarkedDashboard,
  fisrtHalf,
  secoundHalf,
  tdsLOGO,
  clientRequest,
  mca,
  McaMasterData,
  McaFilingStatus,
  McaCompanyDetails,
  McaDashboard,
  McaClients,
  McaServices,
  McaLateFeeCalculator,
  McaLateFeeCalculators,
  HelpAndResources,
  alerttt,
  planner,
  teamscore,
  taskassigned,
  taskcompleted,
  tick,
  plannerWOkring,
  suitcase,
  clock,
  MCA,
  BotIcon,
  zoho_logo,
  sync,
  social,
  viderconnectlogo,
  viderconnecticon,
  checkIcon,
  unifiedCompliance,
  viderIcon,
  redVouchLogo,
  redVouchCard,
  brandIllustration,
  viderConnect,
  AtomCard,
  AtomProCard,
  playStoreIcon,
  appStoreIcon,
  Verified1,
  Verified2,
  Verified3,
  Verified4,
  DpiitEriSslIso,
  SignupBackground,
  ViderLogoFull,
  CALOGO,
  manualDueDt,
  knowledgebaseicon,
  trademarklogo,
  openicon,
  ITALogo,
  GSTAT_ATOM_PRO_LOGO,
  faceCaptureGuide
};

export const icons = {
  totalTasks,
  totalClients,
  taskCompleted,
  taskInprogress,
  taskTodo,
  taskUnderReview,
  checklist_PosterImage,
  handshake_PosterImage,
  socialmedia_PosterImage,
  calendar_PosterImage,
  folder,
  recurring,
  dashboard,
  approvals,
  taskboard,
  calendar,
  lmi,
  reports,
  invoicing,
  team,
  storage,
  storage_sync,
  settings,
  clients,
  leads,
  register,
  dsc,
  gstReturns,
  broadcast,
  logout,
  man,
  profile,
  date,
  shuffle,
  user,
  pdf,
  json,
  doc,
  excel,
  csv,
  text,
  ppt,
  zip,
  video,
  audio,
  recuring,
  formIcon,
  singleLine,
  multiLine,
  email,
  name,
  fileUpload,
  imageUpload,
  termsAndConditions,
  currency,
  signature,
  dropDown,
  decisionBox,
  mobileNumber,
  numbers,
  fieldDate,
  checkBox,
  address,
  file,
  onedrive,
  folderIcon,
  serviceopg1,
  vider_logo_white,
  dsc_Poster_Image,
  file_Poster_Image,
  vider_transparent,
  atomPro,
  mail,
  registerIcon,
  gstrReturns,
  broadcastLogo,
  ViderAI,
  social,
  UPI,
  audit
};
